import { useState } from "react"
import { toast } from "react-hot-toast"

import type { IAccountProductWithTransaction } from "@pamf-my/types"
import SAccountAuthorize from "@/services/account/authorize"

interface Props {
  productCode: IAccountProductWithTransaction["productCode"]
  transactional: IAccountProductWithTransaction["transactional"]
  onClose: (updated: boolean) => void
}

const UpdateAccountTransactionForm = (props: Props) => {
  const { productCode, transactional, onClose } = props
  const [loading, setLoading] = useState(false)

  const activationText = {
    enableSuccess: "Transaction activée avec succès",
    disableSuccess: "Transaction désactivée avec succès",
    error: "Une erreur s'est produite",
  }

  const handleChange = () => {
    setLoading(true)
    SAccountAuthorize({
      accountProductCode: productCode,
      transactional: !transactional,
    })
      .then(res => {
        if (res.success) {
          res.data.transactional === false
            ? toast.success(activationText.disableSuccess)
            : toast.success(activationText.enableSuccess)
        } else {
          toast.error(activationText.error)
        }
        onClose(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <form className="">
      <div className="flex flex-col gap-6 px-6">
        {transactional ? (
          <label htmlFor="admin_role" className="">
            Confirmer la Désactivation du transaction pour le compte{" "}
            <span className="font-bold">{productCode}</span>
          </label>
        ) : (
          <label htmlFor="admin_role" className="">
            Confirmer l'Activation du transaction pour le compte{" "}
            <span className="font-bold">{productCode}</span>
          </label>
        )}
      </div>
      <div className="px-6 -mb-5 bg-surface">
        <div className="flex justify-end gap-4 py-4 mt-8">
          <button
            type="button"
            className="px-4 py-2 rounded-full bg-surface hover:bg-neutral"
            onClick={() => onClose(false)}
          >
            Annuler
          </button>
          <button
            type="button"
            className="px-4 py-2 text-white rounded-full bg-primary hover:opacity-70"
            onClick={() => handleChange()}
          >
            {loading ? "Chargement..." : "Confirmer"}
          </button>
        </div>
      </div>
    </form>
  )
}
export default UpdateAccountTransactionForm
